import React from 'react'
import notfound from '../assets/images/notfound.webp'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'


const NotFound = () => {

  const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "#fff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 2147483646, // very high
  padding: "2rem",
  WebkitOverflowScrolling: "touch",
};
  return (
    <>
      <SEO
        title="Page Not Found | CaptainX"
        titleAr="الصفحة غير موجودة | كابتن اكس"
        description="The page you're looking for doesn't exist. Navigate back to CaptainX homepage."
        descriptionAr="الصفحة التي تبحث عنها غير موجودة. عد إلى الصفحة الرئيسية لكابتن اكس."
        path="/404"
        noindex={true}
      />
      <center>
        <div className='cen-sec-con not-found under'
        style={overlayStyle}
      aria-modal="true"
      role="dialog"
        >
          <img src={notfound} alt='notfound' className='img-fluid' />
          <h2 className='sec-title'>
            <span>Captain X </span>Lost in Space
          </h2>
          <p className='sec-p'>
            Looks like our captain took a wrong turn in the galaxy. Let's help you navigate back to home base.
          </p>
          <Link to="/">
            <button className='explore-btn cta-btn my-4 gap-3'>Back to Home</button>
          </Link>
        </div>
      </center>
    </>
  )
}

export default NotFound